import "core-js/modules/es6.array.index-of";
var n,
    e,
    i,
    o,
    t,
    r,
    f,
    d,
    p,
    u = [];

function w(n, a) {
  return e = window.pageXOffset, o = window.pageYOffset, r = window.innerHeight, d = window.innerWidth, void 0 === i && (i = e), void 0 === t && (t = o), void 0 === p && (p = d), void 0 === f && (f = r), (a || o !== t || e !== i || r !== f || d !== p) && (!function (n) {
    for (var w = 0; w < u.length; w++) {
      u[w]({
        x: e,
        y: o,
        px: i,
        py: t,
        vh: r,
        pvh: f,
        vw: d,
        pvw: p
      }, n);
    }
  }(n), i = e, t = o, f = r, p = d), requestAnimationFrame(w);
}

export default function (e) {
  return u.indexOf(e) < 0 && u.push(e), n = n || w(performance.now()), {
    update: function update() {
      return w(performance.now(), !0), this;
    },
    destroy: function destroy() {
      u.splice(u.indexOf(e), 1);
    }
  };
}